import { render, staticRenderFns } from "./StatsInfo.vue?vue&type=template&id=0c78b879&scoped=true&style=height%3A%20100%25%3B&"
import script from "./StatsInfo.vue?vue&type=script&lang=js&"
export * from "./StatsInfo.vue?vue&type=script&lang=js&"
import style0 from "./StatsInfo.vue?vue&type=style&index=0&id=0c78b879&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c78b879",
  null
  
)

export default component.exports